  (function () {
    function initSpicyProduct(section) {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      var sectionId = section.dataset.sectionId || String(section.id || '').replace('spicy-product-scuffers-', '');
      var cfg = (window.SPX_PRODUCT_CFG || {})[sectionId] || {};

      function spxCfg(key, fallback) {
        return Object.prototype.hasOwnProperty.call(cfg, key) ? cfg[key] : fallback;
      }

      var T = {
        money_format: spxCfg('money_format', ''),
        toast_success: spxCfg('toast_success', 'Producto agregado al carrito'),
        toast_error: spxCfg('toast_error', 'No se pudo agregar'),
        unavailable_text: spxCfg('unavailable_text', 'No disponible'),
        add_to_cart_text: spxCfg('add_to_cart_text', 'Agregar al carrito'),
        soldout_text: spxCfg('soldout_text', 'Agotado'),
        low_stock_custom_text: spxCfg('low_stock_custom_text', 'Pocas unidades disponibles'),
        adding_text: spxCfg('adding_text', 'Agregando...'),
        enable_mobile_sticky: spxCfg('enable_mobile_sticky', true),
        enable_desktop_sticky: spxCfg('enable_desktop_sticky', true)
      };

      var variantsEl = section.querySelector('[data-variants-json]');
      var productEl = section.querySelector('[data-product-json]');
      var variants = [];
      var productData = {};

      try {
        variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
      } catch (error) {
        variants = [];
      }

      try {
        productData = productEl ? JSON.parse(productEl.textContent || '{}') : {};
      } catch (error) {
        productData = {};
      }
      var form = section.querySelector('[data-product-form]');
      var idInput = section.querySelector('[data-variant-id]');
      var stickyAtc = document.querySelector('[data-sticky-atc][data-sticky-owner="' + sectionId + '"]');
      var priceEls = Array.prototype.slice.call(section.querySelectorAll('[data-price], [data-button-price]'));

      if (stickyAtc) {
        priceEls = priceEls.concat(Array.prototype.slice.call(stickyAtc.querySelectorAll('[data-sticky-price], [data-mobile-sticky-price]')));
      }

      var addButton = section.querySelector('[data-add-to-cart]');
      var addText = section.querySelector('[data-add-text]');
      var mobileAdd = stickyAtc ? stickyAtc.querySelector('[data-mobile-add], [data-sticky-add]') : null;
      var lowStock = section.querySelector('[data-low-stock]');
      var lowStockText = section.querySelector('[data-low-stock-text]');
      var selectedColor = section.querySelector('[data-selected-color]');
      var toast = section.querySelector('[data-toast]');
      var gallery = section.querySelector('[data-gallery-scroll]');
      var stage = section.querySelector('.sps-gallery__stage');
      var isLoading = false;
      var isSyncingFromScroll = false;

      function getMainMediaItems() {
        return Array.prototype.slice.call(section.querySelectorAll('[data-main-media]'));
      }

      function getMediaIds() {
        return getMainMediaItems().map(function (el) {
          return String(el.dataset.mediaId);
        });
      }

      function isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      function money(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, productData.money_format || T.money_format);
        }

        var value = Number(cents || 0) / 100;
        return value.toLocaleString('es-CL', {
          style: 'currency',
          currency: 'CLP',
          maximumFractionDigits: 0
        });
      }

      function showToast(text) {
        if (!toast) return;

        toast.textContent = text || T.toast_success;
        toast.classList.add('is-active');

        window.clearTimeout(toast._timer);
        toast._timer = window.setTimeout(function () {
          toast.classList.remove('is-active');
        }, 1800);
      }

      function getSelectedOptions() {
        var selected = [];

        section.querySelectorAll('[data-option-group]').forEach(function (group) {
          var index = Number(group.dataset.optionIndex);
          var active = group.querySelector('[data-option-button].is-active');

          if (active) {
            selected[index] = active.dataset.optionValue;
          }
        });

        return selected;
      }

      function findVariantByOptions(options) {
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === options[index];
          });
        });
      }

      /*
        Disponibilidad progresiva:
        - La primera opción solo se bloquea si no tiene ninguna variante disponible.
        - Las siguientes se validan según las opciones anteriores elegidas.
        Así se evita un callejón sin salida al cambiar, por ejemplo, de color:
        se mantiene el color elegido y se ajusta automáticamente la talla válida.
      */
      function getOptionGroups() {
        return Array.prototype.slice.call(section.querySelectorAll('[data-option-group]'));
      }

      function variantMatchesPreviousOptions(variant, selectedOptions, optionIndex) {
        if (!variant || !variant.available) return false;

        for (var index = 0; index < optionIndex; index += 1) {
          if (selectedOptions[index] && variant.options[index] !== selectedOptions[index]) {
            return false;
          }
        }

        return true;
      }

      function updateOptionAvailability() {
        var selectedOptions = getSelectedOptions();

        getOptionGroups().forEach(function (group) {
          var optionIndex = Number(group.dataset.optionIndex);

          group.querySelectorAll('[data-option-button]').forEach(function (button) {
            var optionValue = button.dataset.optionValue;
            var isAvailable = variants.some(function (variant) {
              return variantMatchesPreviousOptions(variant, selectedOptions, optionIndex) &&
                variant.options[optionIndex] === optionValue;
            });

            button.classList.toggle('is-disabled', !isAvailable);
            button.disabled = !isAvailable;
            button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
            button.tabIndex = isAvailable ? 0 : -1;
          });
        });
      }

      function normalizeSelectionFrom(optionIndex) {
        var selectedOptions = getSelectedOptions();

        /*
          (3-nov-2026, Lucas: «cuando cambio de talla se me cambia el calce también, eso no debe pasar»)
          Si la combinación completa que quedó seleccionada existe y está disponible, no se toca nada:
          cambiar la talla no cambia el calce. Solo cuando esa combinación no existe o está agotada
          se busca otra variante, prefiriendo la que conserve más opciones de las ya elegidas.
        */
        var exactVariant = findVariantByOptions(selectedOptions);
        if (exactVariant && exactVariant.available) return;

        var candidates = variants.filter(function (variant) {
          if (!variant || !variant.available) return false;

          for (var index = 0; index <= optionIndex; index += 1) {
            if (selectedOptions[index] && variant.options[index] !== selectedOptions[index]) {
              return false;
            }
          }

          return true;
        });

        var matchingVariant = null;
        var bestScore = -1;
        candidates.forEach(function (variant) {
          var score = 0;
          for (var index = optionIndex + 1; index < variant.options.length; index += 1) {
            if (selectedOptions[index] && variant.options[index] === selectedOptions[index]) score += 1;
          }
          if (score > bestScore) { bestScore = score; matchingVariant = variant; }
        });

        if (!matchingVariant) return;

        getOptionGroups().forEach(function (group) {
          var groupIndex = Number(group.dataset.optionIndex);

          if (groupIndex <= optionIndex) return;

          group.querySelectorAll('[data-option-button]').forEach(function (button) {
            button.classList.toggle('is-active', button.dataset.optionValue === matchingVariant.options[groupIndex]);
          });
        });
      }

      function setActiveMedia(mediaId, shouldScrollMobile) {
        var mainItems = getMainMediaItems();

        if (!mainItems.length) return;

        if (!mediaId) {
          mediaId = mainItems[0].dataset.mediaId;
        }

        var targetMedia = section.querySelector('[data-main-media][data-media-id="' + mediaId + '"]');

        if (!targetMedia) {
          targetMedia = mainItems[0];
          mediaId = targetMedia.dataset.mediaId;
        }

        mainItems.forEach(function (media) {
          media.classList.toggle('is-active', String(media.dataset.mediaId) === String(mediaId));
        });

        section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
          var active = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', active);

          /*
            MOBILE SCROLL JUMP FIX:
            En celular NO usamos scrollIntoView porque puede mover el viewport completo
            hacia arriba cuando se sincronizan miniaturas/galería o cuando cambia la altura
            del navegador al bajar a la siguiente sección.
          */
          if (active && thumb.scrollIntoView && !isMobile()) {
            thumb.scrollIntoView({
              block: 'nearest',
              inline: 'nearest'
            });
          }

          if (active && isMobile()) {
            var thumbsWrap = thumb.closest('.sps-thumbs');

            if (thumbsWrap) {
              var targetLeft = thumb.offsetLeft - (thumbsWrap.clientWidth / 2) + (thumb.clientWidth / 2);

              if (typeof thumbsWrap.scrollTo === 'function') {
                thumbsWrap.scrollTo({
                  left: Math.max(0, targetLeft),
                  behavior: shouldScrollMobile === false ? 'auto' : 'smooth'
                });
              } else {
                thumbsWrap.scrollLeft = Math.max(0, targetLeft);
              }
            }
          }
        });

        if (isMobile() && shouldScrollMobile !== false && stage && targetMedia) {
          var left = targetMedia.offsetLeft || 0;

          stage.scrollTo({
            left: left,
            behavior: 'smooth'
          });
        }
      }

      function updateUrl(variant) {
        if (!variant || !window.history || !window.history.replaceState) return;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      function updateVariant() {
        updateOptionAvailability();

        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);

        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (mobileAdd) mobileAdd.disabled = true;
          if (addText) addText.textContent = T.unavailable_text;
          if (mobileAdd) mobileAdd.textContent = T.unavailable_text;
          if (lowStock) lowStock.hidden = true;
          return;
        }

        if (idInput) {
          idInput.value = variant.id;
        }

        priceEls.forEach(function (el) {
          el.textContent = money(variant.price);
        });

        if (addButton) {
          addButton.disabled = !variant.available;
        }

        if (mobileAdd) {
          mobileAdd.disabled = !variant.available;
        }

        if (addText) {
          addText.textContent = variant.available
            ? T.add_to_cart_text
            : T.soldout_text;
        }

        if (mobileAdd) {
          mobileAdd.textContent = variant.available
            ? T.add_to_cart_text
            : T.soldout_text;
        }

        if (selectedColor) {
          var colorButton = section.querySelector('.sps-option--color [data-option-button].is-active');

          if (colorButton) {
            selectedColor.textContent = colorButton.dataset.optionValue;
          }
        }

        if (lowStock && lowStockText) {
          var shouldShowLowStock = variant.available;

          lowStock.hidden = !shouldShowLowStock;

          if (shouldShowLowStock) {
            lowStockText.textContent = T.low_stock_custom_text;
          }
        }

        if (variant.featured_media && variant.featured_media.id) {
          setActiveMedia(variant.featured_media.id, true);
        } else if (!section.querySelector('[data-main-media].is-active')) {
          setActiveMedia(null, false);
        }

        updateUrl(variant);
      }

      function openCartDrawer() {
        if (window.SPXCart && typeof window.SPXCart.open === 'function') {
          try {
            window.SPXCart.open();
            return;
          } catch (error) {}
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:updated'));

        window.setTimeout(function () {
          var opened = false;

          if (typeof window.spxRenderCart === 'function') {
            try {
              window.spxRenderCart();
            } catch (error) {}
          }

          if (typeof window.spxOpenCart === 'function') {
            try {
              window.spxOpenCart();
              opened = true;
            } catch (error) {}
          }

          if (!opened) {
            var drawerSelectors = [
              '[data-spx-cart]',
              'cart-drawer',
              '#CartDrawer',
              '.cart-drawer',
              '[data-cart-drawer]',
              '[data-cart-sidebar]',
              '.halo-sidebar.halo-cart-sidebar',
              '#halo-cart-sidebar'
            ];

            drawerSelectors.forEach(function (selector) {
              if (opened) return;

              var drawer = document.querySelector(selector);
              if (!drawer) return;

              drawer.classList.add('is-active');
              drawer.classList.add('active');
              drawer.classList.add('show');
              drawer.classList.add('open');
              drawer.setAttribute('open', '');
              drawer.setAttribute('aria-hidden', 'false');
              drawer.removeAttribute('hidden');

              opened = true;
            });
          }

          if (!opened) {
            var triggers = [
              '[data-spx-cart-open]',
              '[data-cart-drawer-open]',
              '[data-cart-open]',
              '[data-open-cart]',
              '.header__icon--cart',
              '.cart-icon'
            ];

            for (var i = 0; i < triggers.length; i++) {
              var trigger = document.querySelector(triggers[i]);

              if (trigger) {
                try {
                  trigger.click();
                  opened = true;
                  break;
                } catch (error) {}
              }
            }
          }
        }, 150);
      }

      function updateCartCount(count) {
        document.querySelectorAll('[data-cart-count], [data-spx-cart-count], .cart-count-bubble span, .cart-count, .cartCount, .header__cart-count').forEach(function (el) {
          el.textContent = count;

          if (Number(count) > 0) {
            el.hidden = false;
            el.removeAttribute('hidden');
          } else {
            el.hidden = true;
          }
        });
      }

      function addToCart() {
        var selectedVariant = findVariantByOptions(getSelectedOptions());

        if (isLoading || !idInput || !idInput.value || !selectedVariant || !selectedVariant.available) {
          updateVariant();
          return;
        }

        isLoading = true;

        if (addButton) addButton.disabled = true;
        if (mobileAdd) mobileAdd.disabled = true;
        if (addText) addText.textContent = T.adding_text;
        if (mobileAdd) mobileAdd.textContent = T.adding_text;

        var cartAddUrl = '/cart/add.js';

        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          cartAddUrl = window.Shopify.routes.root + 'cart/add.js';
        }

        fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(idInput.value),
            quantity: 1
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () {
                throw new Error(T.toast_error);
              }).then(function (data) {
                throw new Error(data.description || data.message || T.toast_error);
              });
            }

            return response.json();
          })
          .then(function () {
            var cartJsonUrl = '/cart.js';

            if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
              cartJsonUrl = window.Shopify.routes.root + 'cart.js';
            }

            return fetch(cartJsonUrl, { credentials: 'same-origin' }).then(function (response) {
              return response.json();
            });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showToast(T.toast_success);
            openCartDrawer();
          })
          .catch(function (error) {
            showToast(error.message || T.toast_error);
          })
          .finally(function () {
            isLoading = false;
            updateVariant();
          });
      }


      function updateStickyVisibility() {
        if (!stickyAtc) return;

        var stickyEnabled = isMobile()
          ? T.enable_mobile_sticky
          : T.enable_desktop_sticky;

        if (!stickyEnabled) {
          stickyAtc.classList.remove('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'true');
          return;
        }

        /*
          El sticky aparece solamente después de que el botón principal
          salió del viewport. El CSS usa .is-visible para mostrarlo,
          por lo que no queda fijo desde que se carga la página.
        */
        if (!addButton) {
          stickyAtc.classList.add('is-visible');
          stickyAtc.setAttribute('aria-hidden', 'false');
          return;
        }

        // (19-oct-2026, como Scuffers) visible desde el inicio; se esconde mientras el botón principal está en pantalla y vuelve al pasarlo
        var rect = addButton.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var shouldShow = rect.bottom < 0 || rect.top > vh - 40;

        stickyAtc.classList.toggle('is-visible', shouldShow);
        stickyAtc.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      function syncImageWithDesktopScroll() {
        return;
      }

      function syncThumbsWithMobileSwipe() {
        if (!stage || !isMobile()) return;

        var mainItems = getMainMediaItems();

        if (!mainItems.length) return;

        var index = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
        var media = mainItems[Math.max(0, Math.min(index, mainItems.length - 1))];

        if (media) {
          setActiveMedia(media.dataset.mediaId, false);
        }
      }

      section.querySelectorAll('[data-option-button]').forEach(function (button) {
        button.addEventListener('click', function () {
          var group = button.closest('[data-option-group]');

          if (!group || button.classList.contains('is-disabled') || button.disabled) return;

          group.querySelectorAll('[data-option-button]').forEach(function (item) {
            item.classList.remove('is-active');
          });

          button.classList.add('is-active');

          /*
            Si la opción elegida invalida una opción posterior, se elige
            automáticamente la primera variante disponible compatible.
            Nunca queda una combinación inexistente seleccionada.
          */
          normalizeSelectionFrom(Number(group.dataset.optionIndex));
          updateOptionAvailability();
          updateVariant();
        });
      });

      section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setActiveMedia(thumb.dataset.mediaId, true);
        });
      });

      section.querySelectorAll('[data-main-media]').forEach(function (media) {
        media.addEventListener('click', function () {
          // (19-oct-2026) tocar la foto la abre grande a pantalla completa; ahí se desliza a las demás (assets/spicy-visor.js)
          if (window.spicyVisor) {
            var fotos = getMainMediaItems().map(function (el) {
              var img = el.querySelector('img');
              return img ? { id: el.dataset.mediaId, src: img.getAttribute('src'), w: Number(img.getAttribute('width')) || 0, h: Number(img.getAttribute('height')) || 0 } : null;
            }).filter(Boolean);
            window.spicyVisor.abrir(fotos, media.dataset.mediaId, function (idVisto) { if (idVisto) setActiveMedia(idVisto, true); });
            return;
          }
          if (isMobile()) return;

          var activeThumb = section.querySelector('[data-thumb].is-active');
          var nextThumb = activeThumb && activeThumb.nextElementSibling
            ? activeThumb.nextElementSibling
            : section.querySelector('[data-thumb]');

          if (nextThumb) {
            setActiveMedia(nextThumb.dataset.mediaId, false);
          }
        });
      });

      if (stage) {
        stage.addEventListener('scroll', function () {
          if (!isMobile()) return;

          window.clearTimeout(stage._spsScrollTimer);
          stage._spsScrollTimer = window.setTimeout(syncThumbsWithMobileSwipe, 80);
        }, { passive: true });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          addToCart();
        });
      }

      if (mobileAdd) {
        mobileAdd.addEventListener('click', addToCart);
      }

      var sizeGuideModal = document.getElementById('sps-size-guide-modal-' + sectionId);
      var sizeGuideLastTouchY = 0;

      function lockSizeGuidePage() {
        document.documentElement.classList.add('sps-size-guide-open');
        document.body.classList.add('sps-size-guide-open');
      }

      function unlockSizeGuidePage() {
        document.documentElement.classList.remove('sps-size-guide-open');
        document.body.classList.remove('sps-size-guide-open');
      }

      function getSizeGuideScrollArea() {
        return sizeGuideModal ? sizeGuideModal.querySelector('[data-size-guide-scroll]') : null;
      }

      function openSizeGuide(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        var modal = sizeGuideModal || document.getElementById('sps-size-guide-modal-' + sectionId);

        if (!modal) {
          console.warn('No existe modal de guía de tallas para este producto. Revisa que Product Info Blocks tenga una imagen o carga una guía fallback en el personalizador.');
          return;
        }

        sizeGuideModal = modal;
        modal.hidden = false;
        modal.removeAttribute('hidden');
        var scrollArea = modal.querySelector('[data-size-guide-scroll]');
        if (scrollArea) scrollArea.scrollTop = 0;
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        lockSizeGuidePage();
      }

      function closeSizeGuide(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        var modal = sizeGuideModal || document.getElementById('sps-size-guide-modal-' + sectionId);
        if (!modal) return;

        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        modal.hidden = true;
        unlockSizeGuidePage();
      }

      function preventSizeGuideScrollLeak(event) {
        if (!sizeGuideModal || !sizeGuideModal.classList.contains('is-active')) return;

        var scrollArea = getSizeGuideScrollArea();
        if (!scrollArea) {
          event.preventDefault();
          return;
        }

        var targetInsideScroll = event.target === scrollArea || scrollArea.contains(event.target);
        if (!targetInsideScroll) {
          event.preventDefault();
          return;
        }
      }

      function preventSizeGuideTouchLeak(event) {
        if (!sizeGuideModal || !sizeGuideModal.classList.contains('is-active')) return;
        // (Lucas, 20-oct-2026: «Encuentra tu talla no me responde bien al dedo») no frenar el pellizco de dos dedos (zoom a la tabla),
        // el movimiento con la página ya ampliada, ni el arrastre de los deslizadores de estatura y peso
        if (event.touches && event.touches.length > 1) return;
        if (window.visualViewport && window.visualViewport.scale > 1.01) return;
        if (event.target && event.target.closest && event.target.closest('input[type=range]')) return;

        var scrollArea = getSizeGuideScrollArea();
        if (!scrollArea) return;

        var touch = event.touches && event.touches[0];
        if (!touch) return;

        var currentY = touch.clientY;
        var deltaY = currentY - sizeGuideLastTouchY;
        var atTop = scrollArea.scrollTop <= 0;
        var atBottom = Math.ceil(scrollArea.scrollTop + scrollArea.clientHeight) >= scrollArea.scrollHeight;

        if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
          event.preventDefault();
        }
      }

      section.querySelectorAll('[data-size-guide-open]').forEach(function (button) {
        button.addEventListener('click', openSizeGuide);
      });

      if (sizeGuideModal) {
        sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function (button) {
          button.addEventListener('click', closeSizeGuide);
        });

        sizeGuideModal.addEventListener('wheel', preventSizeGuideScrollLeak, { passive: false });

        sizeGuideModal.addEventListener('touchstart', function (event) {
          var touch = event.touches && event.touches[0];
          sizeGuideLastTouchY = touch ? touch.clientY : 0;
        }, { passive: true });

        sizeGuideModal.addEventListener('touchmove', preventSizeGuideTouchLeak, { passive: false });
      }
      var escapeHandlerKey = 'spsSizeGuideEscape' + sectionId;
      var escapeHandlerReadyKey = escapeHandlerKey + 'Ready';

      window[escapeHandlerKey] = window[escapeHandlerKey] || function (event) {
        if (event.key !== 'Escape') return;

        var modal = document.getElementById('sps-size-guide-modal-' + sectionId);
        if (!modal || !modal.classList.contains('is-active')) return;

        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        modal.hidden = true;
        document.documentElement.classList.remove('sps-size-guide-open');
        document.body.classList.remove('sps-size-guide-open');
      };

      if (!window[escapeHandlerReadyKey]) {
        document.addEventListener('keydown', window[escapeHandlerKey]);
        window[escapeHandlerReadyKey] = true;
      }

      var unloadHandlerKey = 'spsSizeGuideUnload' + sectionId;
      var unloadHandlerReadyKey = unloadHandlerKey + 'Ready';

      window[unloadHandlerKey] = window[unloadHandlerKey] || function () {
        var modal = document.getElementById('sps-size-guide-modal-' + sectionId);
        if (modal) {
          modal.classList.remove('is-active');
          modal.setAttribute('aria-hidden', 'true');
          modal.hidden = true;
        }

        document.documentElement.classList.remove('sps-size-guide-open');
        document.body.classList.remove('sps-size-guide-open');
      };

      if (!window[unloadHandlerReadyKey]) {
        document.addEventListener('shopify:section:unload', window[unloadHandlerKey]);
        window[unloadHandlerReadyKey] = true;
      }

      window.addEventListener('scroll', function () {
        syncImageWithDesktopScroll();
        updateStickyVisibility();
      }, { passive: true });
      window.addEventListener('resize', function () {
        /*
          MOBILE SCROLL JUMP FIX:
          En Chrome/Safari mobile, al bajar la barra del navegador cambia de alto
          y dispara resize varias veces. Si sincronizamos galería en ese resize,
          la página puede saltar al inicio del producto.
        */
        updateStickyVisibility();

        if (isMobile()) return;

        setActiveMedia(
          (section.querySelector('[data-main-media].is-active') || section.querySelector('[data-main-media]') || {}).dataset && (section.querySelector('[data-main-media].is-active') || section.querySelector('[data-main-media]')).dataset.mediaId,
          false
        );

        syncImageWithDesktopScroll();
      });

      updateVariant();

      if (!section.querySelector('[data-main-media].is-active')) {
        var firstMainMedia = section.querySelector('[data-main-media]');

        if (firstMainMedia) {
          setActiveMedia(firstMainMedia.dataset.mediaId, false);
        }
      }

      syncImageWithDesktopScroll();
      updateStickyVisibility();
    }

    function boot() {
      document.querySelectorAll('[data-spicy-product-scuffers]').forEach(initSpicyProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-spicy-product-scuffers]');

      if (section) {
        section.dataset.ready = 'false';
        initSpicyProduct(section);
      }
    });
  })();

  /* =========================================================
     PRECARGA DIFERIDA DE LA GALERIA (FIX rectangulo blanco)
     Las diapositivas 2..N del carrusel viven dentro de
     .sps-gallery__sticky, que tiene overflow:hidden y alto fijo,
     por lo que el navegador considera que estan fuera de pantalla
     y nunca pide las imagenes con loading="lazy". Al hacer swipe o
     cambiar de variante aparecia un rectangulo blanco.
     Aqui NO se toca el HTML: el markup sigue con la primera imagen
     eager y el resto lazy (asi no se pierde la optimizacion de
     velocidad del primer pintado). Despues del primer pintado, y
     solo cuando el navegador esta libre, forzamos la descarga de
     las restantes de a 2, con prioridad baja.
     Es idempotente, tolerante a fallos y no hace nada si la pagina
     no tiene .sps-gallery.
     ========================================================= */
  (function () {
    var GALLERY_SELECTOR = '.sps-gallery';
    var IMAGE_SELECTOR = '.sps-gallery__img';
    var SLIDE_SELECTOR = '.sps-gallery__image';
    var STAGE_SELECTOR = '.sps-gallery__stage';
    var BATCH_SIZE = 2;
    var IDLE_TIMEOUT = 2500;
    var LOAD_FALLBACK_DELAY = 1200;
    var PER_IMAGE_TIMEOUT = 8000;
    var DECODE_TIMEOUT = 3000;

    var scheduled = false;
    var running = false;

    function isLoaded(img) {
      return !!(img && img.complete && img.naturalWidth > 0);
    }

    function toArray(list) {
      var out = [];

      if (!list) return out;

      for (var i = 0; i < list.length; i += 1) out.push(list[i]);

      return out;
    }

    /*
      Indice de la diapositiva visible: primero la clase is-active (la
      pone la galeria al cambiar de miniatura o de variante), despues el
      scroll horizontal del stage (swipe en movil) y, si nada de eso
      esta disponible, la primera.
    */
    function getActiveIndex(gallery, slides) {
      try {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i].classList && slides[i].classList.contains('is-active')) return i;
        }

        var activeMedia = gallery.querySelector('[data-main-media].is-active');

        if (activeMedia && typeof activeMedia.closest === 'function') {
          var slide = activeMedia.closest(SLIDE_SELECTOR);
          var found = slides.indexOf(slide);

          if (found >= 0) return found;
        }

        var stage = gallery.querySelector(STAGE_SELECTOR);

        if (stage && stage.clientWidth > 0 && slides.length) {
          var guess = Math.round(stage.scrollLeft / stage.clientWidth);

          return Math.max(0, Math.min(guess, slides.length - 1));
        }
      } catch (error) {}

      return 0;
    }

    function slideIndexOf(slides, img, fallback) {
      try {
        if (typeof img.closest === 'function') {
          var found = slides.indexOf(img.closest(SLIDE_SELECTOR));

          if (found >= 0) return found;
        }
      } catch (error) {}

      return fallback;
    }

    /*
      Peso de prioridad: la siguiente diapositiva primero, luego la
      anterior, luego +2, -2, etc. Lo que el usuario va a ver al primer
      swipe se calienta y se decodifica antes que el resto.
    */
    function priorityRank(index, active) {
      var delta = index - active;

      if (delta === 0) return 0;

      return Math.abs(delta) * 2 + (delta > 0 ? 0 : 1);
    }

    function getPendingInGallery(gallery) {
      var entries = [];
      var out = [];

      try {
        var slides = toArray(gallery.querySelectorAll(SLIDE_SELECTOR));
        var images = toArray(gallery.querySelectorAll(IMAGE_SELECTOR));
        var active = getActiveIndex(gallery, slides);

        for (var j = 0; j < images.length; j += 1) {
          var img = images[j];

          if (img.getAttribute('data-spx-warmed') === 'true') continue;
          if (isLoaded(img)) continue;

          var index = slideIndexOf(slides, img, j);

          entries.push({ img: img, rank: priorityRank(index, active), order: j });
        }

        entries.sort(function (a, b) {
          if (a.rank !== b.rank) return a.rank - b.rank;

          return a.order - b.order;
        });

        for (var k = 0; k < entries.length; k += 1) out.push(entries[k].img);
      } catch (error) {}

      return out;
    }

    function getPendingImages() {
      var pending = [];

      try {
        var galleries = document.querySelectorAll(GALLERY_SELECTOR);

        for (var i = 0; i < galleries.length; i += 1) {
          pending = pending.concat(getPendingInGallery(galleries[i]));
        }
      } catch (error) {}

      return pending;
    }

    function warmImage(img, done) {
      var finished = false;
      var released = false;
      var timer = 0;

      function release() {
        if (released) return;
        released = true;

        done();
      }

      /*
        Descargar el archivo no deja el bitmap listo: decodificar un JPEG
        grande en un telefono tarda, y ese es el rectangulo en blanco que
        se ve durante el swipe. Con decode() pagamos ese costo antes,
        mientras el navegador esta libre.
        decode() rechaza en varios casos (imagen con error, src cambiado,
        Safari quisquilloso) y ademas puede quedarse colgado: cualquier
        fallo solo adelanta el paso a la siguiente imagen, nunca corta la
        cadena de precarga.
      */
      function decodeThenRelease() {
        var guard = 0;

        try {
          if (typeof img.decode !== 'function') {
            release();
            return;
          }

          var promise = img.decode();

          if (!promise || typeof promise.then !== 'function') {
            release();
            return;
          }

          guard = window.setTimeout(release, DECODE_TIMEOUT);

          promise.then(
            function () {
              window.clearTimeout(guard);
              release();
            },
            function () {
              window.clearTimeout(guard);
              release();
            }
          );
        } catch (error) {
          window.clearTimeout(guard);
          release();
        }
      }

      function finish() {
        if (finished) return;
        finished = true;

        window.clearTimeout(timer);

        try {
          img.removeEventListener('load', finish);
          img.removeEventListener('error', finish);
        } catch (error) {}

        decodeThenRelease();
      }

      timer = window.setTimeout(finish, PER_IMAGE_TIMEOUT);

      try {
        img.setAttribute('data-spx-warmed', 'true');

        img.addEventListener('load', finish);
        img.addEventListener('error', finish);

        /*
          Pasar loading a 'eager' sobre un <img> ya insertado dispara la
          descarga en los navegadores actuales. fetchPriority 'low' evita
          competir con el resto de la pagina.
        */
        img.loading = 'eager';
        img.setAttribute('loading', 'eager');

        if ('fetchPriority' in img) {
          img.fetchPriority = 'low';
        }

        img.setAttribute('fetchpriority', 'low');

        /*
          Respaldo de compatibilidad (Safari antiguo): calentamos la cache
          con una copia fuera del DOM usando el mismo srcset/sizes.
        */
        var warmer = new Image();

        if (img.sizes) warmer.sizes = img.sizes;
        if (img.srcset) warmer.srcset = img.srcset;
        if (img.currentSrc || img.src) warmer.src = img.currentSrc || img.src;

        if (isLoaded(img)) {
          finish();
        }
      } catch (error) {
        finish();
      }
    }

    function preloadRest() {
      if (running) return;

      var queue = getPendingImages();

      if (!queue.length) return;

      running = true;

      function step() {
        var batch = queue.splice(0, BATCH_SIZE);

        if (!batch.length) {
          running = false;
          return;
        }

        var remaining = batch.length;

        batch.forEach(function (img) {
          warmImage(img, function () {
            remaining -= 1;

            if (remaining <= 0) step();
          });
        });
      }

      step();
    }

    function preloadNow() {
      scheduled = true;

      try {
        preloadRest();
      } catch (error) {}
    }

    function schedulePreload() {
      if (scheduled) return;
      scheduled = true;

      try {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(function () {
            preloadNow();
          }, { timeout: IDLE_TIMEOUT });
        } else {
          window.setTimeout(preloadNow, LOAD_FALLBACK_DELAY);
        }
      } catch (error) {
        window.setTimeout(preloadNow, LOAD_FALLBACK_DELAY);
      }
    }

    function matches(node, selector) {
      return !!(node && typeof node.closest === 'function' && node.closest(selector));
    }

    function onGalleryInteract(event) {
      try {
        if (matches(event.target, GALLERY_SELECTOR)) preloadNow();
      } catch (error) {}
    }

    function onVariantInteract(event) {
      try {
        if (matches(event.target, '[data-option-button]') || matches(event.target, '[data-thumb]')) {
          preloadNow();
        }
      } catch (error) {}
    }

    try {
      /* Capture: se adelanta aunque otro handler llame a stopPropagation(). */
      document.addEventListener('pointerdown', onGalleryInteract, { passive: true, capture: true });
      document.addEventListener('touchstart', onGalleryInteract, { passive: true, capture: true });
      document.addEventListener('click', onVariantInteract, { passive: true, capture: true });
      document.addEventListener('change', onVariantInteract, { passive: true, capture: true });

      document.addEventListener('shopify:section:load', function () {
        window.setTimeout(preloadNow, 0);
      });

      if (document.readyState === 'complete') {
        schedulePreload();
      } else {
        window.addEventListener('load', schedulePreload, { once: true });
      }
    } catch (error) {}
  })();

